import type { IconData } from '@stacksjs/iconify-core'

export const drinkFoodCookie: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11 4c.39 0 .763-.075 1.105-.21a3 3 0 0 0 3.62 2.122A8 8 0 1 1 8.17.002A3 3 0 0 0 11 4M4 7a1 1 0 1 0 0-2a1 1 0 0 0 0 2m8 4a1 1 0 1 1-2 0a1 1 0 0 1 2 0m-6 2a1 1 0 1 0 0-2a1 1 0 0 0 0 2\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default drinkFoodCookie
